const apiBaseUrl = "https://736hp66h8f.execute-api.us-west-2.amazonaws.com/prod/";
export default apiBaseUrl;